import React from "react";
import PropTypes from "prop-types";

const TopHeader = ({ title,shortId, children }) => {
  return (
    <div className="c-top-nav">
      <div className="l-content-width">
        <header>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {title} {shortId && <span>{shortId}</span>}
              </li>
            </ol>
          </nav>
        </header>
      </div>
    </div>
  );
};

TopHeader.propTypes = {
  title: PropTypes.string,
  shortId: PropTypes.string,
  children: PropTypes.node};

export default TopHeader;
